export default "__VITE_ASSET__Bn9p1DmU__"